export default "/images/vendor/flag-icon-css/flags/4x3/as.svg?3b86b6876653592c0fa31eb96c570867";